// AdminLayout scrolls in one of two places: its [data-main-container] box from lg up, and the page
// itself below lg (so iOS's tap-the-status-bar-to-go-to-the-top works). Anything that scrolls the
// main content has to ask which one is live, or it scrolls a box that cannot move.
const getMainScrollContainer = (): HTMLElement | null => {
  const container = document.querySelector<HTMLElement>(
    '[data-main-container]',
  );
  if (!container) {
    return null;
  }
  const { overflowY } = window.getComputedStyle(container);
  const canScroll =
    (overflowY === 'auto' || overflowY === 'scroll') &&
    container.scrollHeight > container.clientHeight;
  return canScroll ? container : null;
};

// Scrolls the main content so the element sits headerOffset px below the top of whatever scrolls.
export const scrollMainToElement = (
  element: HTMLElement,
  headerOffset: number,
): void => {
  const container = getMainScrollContainer();
  if (container) {
    container.scrollTo({
      top: element.offsetTop - headerOffset,
      behavior: 'smooth',
    });
    return;
  }
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - headerOffset,
    behavior: 'smooth',
  });
};
